import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
import BaoDialogViewModel from "./../factories/bao-dialog";
function SoftwareTypeViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(SoftwareTypeViewModel, SearchPaging);
SoftwareTypeViewModel.prototype.PrimaryKey = "SoftwareTypeId";
SoftwareTypeViewModel.prototype.RefreshUrl = "SoftwareType/Get";
SoftwareTypeViewModel.prototype.SaveUrl = "SoftwareType/Save";
SoftwareTypeViewModel.prototype.DeleteUrl = "SoftwareType/Delete";
SoftwareTypeViewModel.prototype.IsInUseUrl = "SoftwareType/IsInUse";
SoftwareTypeViewModel.prototype.PermissionForward = "SoftwareTypeMoveForwardSearch";
SoftwareTypeViewModel.prototype.PermissionBackward = "SoftwareTypeMoveBackwardSearch";
SoftwareTypeViewModel.prototype.PermissionSave = "SoftwareTypeSave";
SoftwareTypeViewModel.prototype.PermissionRefresh = "SoftwareTypeRefresh";
SoftwareTypeViewModel.prototype.PermissionDelete = "SoftwareTypeDelete";
export default SoftwareTypeViewModel;